export default __webpack_public_path__ + "static/media/diners_club.030cbb90.svg";